import { useParams } from 'react-router';

export const useCurrentChannelGuid = (): string | undefined => {
  const { channelGuid } = useParams<{ channelGuid: string }>();
  return channelGuid;
};
